import type { AgeingBucketKey } from '../types/ceoDashboard';

export const OVERVIEW_STALE_MS = 5 * 60 * 1000;
export const DETAILS_STALE_MS = 5 * 60 * 1000;

/** The CEO: Super Admin role holding permission 1. */
export const CEO_ROLE_ID = 100;
export const CEO_PERMISSION_ID = 1;

export const TOP_LIST_SIZE = 5;
/** The donut shows this many categories; the rest fold into "Other". */
export const DONUT_SLICES = 7;

export type PeriodPreset = 'THIS_MONTH' | 'LAST_MONTH' | 'THIS_QUARTER' | 'THIS_YEAR' | 'CUSTOM';

export const PERIOD_PRESETS: { key: PeriodPreset; label: string }[] = [
  { key: 'THIS_MONTH', label: 'This month' },
  { key: 'LAST_MONTH', label: 'Last month' },
  { key: 'THIS_QUARTER', label: 'This quarter' },
  { key: 'THIS_YEAR', label: 'This year' },
  { key: 'CUSTOM', label: 'Custom' },
];

/**
 * One accent per area. Hues are the validated categorical slots of the dataviz reference
 * palette (blue, aqua, orange, violet, magenta), so neighbouring areas never read alike.
 */
export const ACCENT = {
  revenue: '#2a78d6',
  invoice: '#1baf7a',
  expense: '#eb6834',
  cash: '#6250d6',
  operations: '#0f766e',
  people: '#d55181',
} as const;

/** Categorical order for the expense donut, never cycled; slot 8 is "Other" grey. */
export const CATEGORY_COLORS = [
  '#2a78d6',
  '#eb6834',
  '#1baf7a',
  '#eda100',
  '#e87ba4',
  '#008300',
  '#6250d6',
] as const;
export const OTHER_COLOR = '#94a3b8';

/** Ageing reads light to dark as the debt gets older: one hue per ledger. */
export const AGEING_BUCKETS: { key: AgeingBucketKey; label: string }[] = [
  { key: 'CURRENT', label: 'Current' },
  { key: 'D1_30', label: '1–30' },
  { key: 'D31_60', label: '31–60' },
  { key: 'D61_90', label: '61–90' },
  { key: 'OVER_90', label: '90+' },
];
export const RECEIVABLE_RAMP = ['#bfdbfe', '#93c5fd', '#3b82f6', '#1d4ed8', '#1e3a8a'] as const;
export const PAYABLE_RAMP = ['#fed7aa', '#fdba74', '#f97316', '#c2410c', '#7c2d12'] as const;
